module.exports = "/static/assets/82af801032eddde66a0163e50fcfe095.png";